'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminController = function AdminController(User, $scope, $rootScope, $cookieStore, FunctionService) {
  _classCallCheck(this, AdminController);

  console.log('Admin Controller...');
  this.name = 'admin';
  this.user = User.getUser();
  this.episodeValue = '';
  this.specialtyString = '';

  $rootScope.globals = $cookieStore.get('globals') || {};
  $cookieStore.remove('redirectURL');

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    if (response.functionSettings.EpisodeValue) {
      $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
      $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    }
  });
};

exports.default = AdminController;


// WEBPACK FOOTER //
// ./client/app/components/admin/admin.controller.js